import React, { Component, Fragment } from 'react'
import Slider from './slider/Slider'
import { withRouter } from 'react-router-dom';
import TripListSkeleton from '../skeleton/TripListSkeleton';
import LayoutSwithingSkeleton from '../skeleton/LayoutSwithingSkeleton';
import FilterSkeleton from '../skeleton/FilterSkeleton';
import TravelDocumentSkeleton from '../skeleton/TravelDocumentSkeleton';
import CheckoutSkeleton from '../skeleton/checkout/CheckoutSkeleton';
import AddonWithMediaSkeleton from '../skeleton/checkout/AddonWithMediaSkeleton';

class Test extends Component {

    componentDidMount() {
        document.body.style.opacity = "1";
        // alert()
    }

    /* render() {
         return (
             <Fragment>
             <div class="sidebar-wrapper show-sidebar" >
             <div class="close-side-bar">
                 <img src="images/side-close.png" class="img-fluid"/>
             </div>
             <div class="sidebar" id="scroll-side">
                <div class="slide-wrapper">
                    <Slider/>
                </div>
                <div class="side-content-wrapper">
                    <div class="heading-wrapper">
                        <div class="caption">
                         <h6>CANADA, BIG WHITE</h6>
                         <h2>Mountains Hiking</h2> 
                        </div>
                        <div class="pricing">
                            <h4>fra kr. 16.599,-</h4>
                        </div>
                    </div> 
                    <div class="content">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Id porta nibh venenatis cras sed felis eget velit aliquet. Ut eu sem integer vitae justo eget magna fermentum. Feugiat pretium nibh ipsum consequat nisl vel pretium lectus. Lobortis mattis aliquam faucibus purus in massa. Nec feugiat in fermentum posuere urna. Nullam ac tortor vitae purus. Auctor neque vitae tempus quam pellentesque nec nam aliquam sem. Eu mi bibendum neque egestas congue quisque egestas diam in. Sollicitudin aliquam ultrices sagittis orci. Odio facilisis mauris sit amet. Est velit egestas.
                     Pharetra magna ac placerat vestibulum lectus. Id aliquet lectus proin nibh nisl condimentum. </p>
                     <ul>
                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                     </ul>
                 </div>
                 <div class="variation-wrapper">
                     <div class="block-content">
                     <label>test</label>
                     <p>test</p>
                     </div>
                     <div class="block-content">
                     <label>test</label>
                     <select>
                         <option>test</option>
                         <option>test</option>
                         <option>test</option>
                         </select>
                     </div>
                 </div>
                 <div class="more-btn">
                     <a href="" class="custom-btn">
                         <span>Gå til booking</span>
                     </a>
                 </div>
                </div>
             </div>
         </div>
      
      
      
      
      
      
         <section class="banner" >
             <div class="banner-wrapper">
                 <div class="container">
                             <div class="banner-caption-content">
                         <h1>Søg efter din næste rejse</h1>
                         </div>
                 </div>
             </div>
         </section>
         
         <div class="filter-nav" id="filterHeader">
             <div class="navigation">
                     <div class="menu-wrapper">
                         <div class="nav-menu">
                             <ul class="firstlevel">
                                 <li class="has-sub">
                                     <a>AFREJSE DATO
                                       <span class="subname"><span class="startdate">5/8/2020</span><span class="enddate">5/8/2020</span></span>
                                         <span class="arrow"></span>
                                     </a>
                                     <ul class="sub">
                                         <li>
                                                 <a>
                                                         <span class="subname">Sub menu 1</span>
                                                     </a>
                                         </li>
                                     </ul>
                                 </li>
                                 <li class="has-sub">
                                         <a>hvortil?
                                             <span class="subname">2 valgte</span>
                                             <span class="arrow"></span>
                                         </a>
                                         <ul class="sub">
                                             <li>
                                                 <div class="check-group">
                                                         <form>
                                                             <div class="search-box">
                                                                 <input type="text" name="text" placeholder="search your cities"/>
                                                             </div>
                                                             <div class="check-wrapper">
                                                              
                                                                 <div class="form-group">
                                                                   <input type="checkbox" id="1"/>
                                                                   <label for="1">Canada</label>
                                                                 </div>
                                                                 
                                                              
             
                                                                 </div>
                                                               </form>
                                                 </div>
                                             </li>
                                         </ul>
                                     </li>
         
                                 <li>
                                     <a href="#">Årstid
                                         <span class="subname">Vælg</span>
                                     </a>
                                 </li>
         
                                 <li>
                                     <a href="#">Længde
                                         <span class="subname">Vælg</span>
                                     </a>
                                 </li>
         
                                 <li>
                                     <a href="#">Type
                                         <span class="subname">Type</span>
                                     </a>
                                 </li>
                            
                            
                                 <li class="has-sub">
                                     <a href="#">Type
                                         <span class="subname">Ikke relevant</span>
                                         <span class="arrow"></span>
                                     </a>
                                     <ul class="sub">
                                         <li>
                                             <a>
                                                 <span class="subname">Sub menu 1</span>
                                             </a>
                                         </li>
                                         <li>
                                             <a>
                                                 <span class="subname">Sub menu 2</span>
                                             </a>
                                         </li>
                                         <li>
                                             <a>
                                                 <span class="subname">Sub menu 3</span>
                                             </a>
                                         </li>
                                     </ul>
                                 </li>
                              
                             </ul>
         
         
                         </div>
         
         
         
                     </div>
                     <div class="initial-content">
                         <div class="initial-block-wrapper">
                             <div class="initial-block-content">
                                 <p>
                                     <span class="text-bold">Hvor mange skal rejse?</span>
                                 </p>
                             </div>
                             
                             <div class="add-minus-wrapper">
                                 <div class="add-minus-wrap">
                                     
                                         <div class="block-wrap">
                                                 <div class="add-btn"><button class="custom-addminus-btn"><img src="images/plus-3x.png" class="img-fluid" alt="add-btn"/></button></div>
                                                 <div class="minus-btn"><button class="custom-addminus-btn"><img src="images/minus-icon.svg" class="img-fluid" alt="add-btn"/></button></div>
                                                 <div class="count-text"><span class="count-number">2</span>voksne</div>
                                         
                                         </div>
                                         </div>
                                 </div>
                         </div>
                     </div>
         
             </div>
         </div>
         
         <div class="cards-top-bar">
                 <div class="container">
                     <div class="cards-top-bar-wrapper">
                     <div class="head-content">
                         <h3>37 matchende rejser fundet</h3>
                     </div>
                     <div class="option-content">
                         <div class="select-option-content">
                         <select>
                             <option>test</option>
                             <option>test</option>
                             <option>test</option>
                         </select>
                     </div>
                     <div class="grid-list-icons">
                             <ul>
                                 <li class="active-card-lay-out"><a href="">
                                  
                                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" fill="" viewBox="0 0 18 15">
                                         <path fill="#BDC0C3" d="M0 8.836h3V5.891H0v2.945zm0-5.89h3V0H0v2.945zm0 11.781h3v-2.945H0v2.945zm6-5.89h12V5.89H6v2.945zm0-5.892h12V0H6v2.945zm0 11.782h12v-2.945H6v2.945z"/>
                                     </svg>
                                     
                                 </a></li>
                                 <li><a href="">
                                  
                                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="" viewBox="0 0 18 18">
                                         <path fill="#BDC0C3" d="M0 0h4.5v4.5H0V0zm6.75 0h4.5v4.5h-4.5V0zm6.75 0H18v4.5h-4.5V0zM0 6.75h4.5v4.5H0v-4.5zm6.75 0h4.5v4.5h-4.5v-4.5zm6.75 0H18v4.5h-4.5v-4.5zM0 13.5h4.5V18H0v-4.5zm6.75 0h4.5V18h-4.5v-4.5zm6.75 0H18V18h-4.5v-4.5z" />
                                     </svg>
                                     
                                 </a></li>
                             </ul>
                         </div>
                     </div>
                 </div>
                 </div>
                 </div>
         
         
                 <div class="col-box two-col-layout">
             <div class="container">
                 <div class="col-wrapper">
                
                     <div class="cards">
                         <div class="cards-wrapper">
                             <figure>
                                 <div class="card-image">
                                     <div class="image-for-card"  style={{ backgroundImage: `url(http://snowminds.camps.s.cmshelp.dk/images/box-image.png)` }} ></div>
                                     <div class="flag"><img src="images/flag.png" class="img-fluid" alt="flag"/></div>
                                     <div class="heart"><img src="images/heart.svg" class="img-fluid"/></div>
                                 </div>
                                 <figcaption>
                                     <div class="card-content">
                                         <div class="card-head">
                                             <div class="heading">
                                                 <p>Honshu</p>
                                                 <h2>Mountains Hiking</h2>
                                             </div>
                                             <div class="price">
                                                 <h3>fra kr. 16.599,-</h3>
                                             </div>
                                         </div>
                                         <div class="card-body">
                                             <div class="catogoty-tag-wrapper">
                                                 <a href="" class="cateogry-tag green-tag">Lorem ipsum</a>
         
                                                 <a href="" class="cateogry-tag orange-tag">Lorem ipsum</a>
         
                                                 <a href="" class="cateogry-tag blue-tag">Lorem ipsum</a>
         
                                             </div>
                                             <div class="description">
                                                 <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, vestibulum molestie id quam
                                                     nec ultrices. Lorem ipsum dolor sit amet, consectetur adipiscing elit, molestie
                                                     id quam nec.</p>
                                                     <div class="list-details">
                                                             <div class="mobile-listing">mobile listing</div>
                                                     <ul>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                     </ul>
                                                 </div>
                                             </div>
                                         </div>
                                         <div class="card-footer">
                                             <div class="selected-wrappers">
                                                 <div class="content-block">
                                                     <p>
                                                         <span class="text-bold">Variation</span>
                                                     </p>
                                                     <p>Variation</p>
                                                 </div>
                                                 <div class="content-block">
                                                     <p>
                                                         <span class="text-bold">Variation</span>
                                                     </p>
                                                     <p>Variation</p>
                                                 </div>
                                                 <div class="content-block card-btn">
                                                     <a href="" class="custom-btn">
                                                         <span>Gå til booking</span>
                                                     </a>
                                                     <a class="link-btn">Læs mere om rejsen</a>
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                 </figcaption>
                             </figure>
                         </div>
                     </div>
                  
 
                     <div class="cards">
                         <div class="cards-wrapper">
                             <figure>
                                 <div class="card-image">
                                     <div class="image-for-card" /></div>
                                         <div class="flag"><img src="images/flag.png" class="img-fluid" alt="flag"/></div>
                                         <div class="heart"><img src="images/heart.svg" class="img-fluid"/></div>
                               
                                 <figcaption>
                                     <div class="card-content">
                                         <div class="card-head">
                                             <div class="heading">
                                                 <p>Honshu</p>
                                                 <h2>Mountains Hiking</h2>
                                             </div>
                                             <div class="price">
                                                 <h3>fra kr. 16.599,-</h3>
                                             </div>
                                         </div>
                                         <div class="card-body">
                                             <div class="catogoty-tag-wrapper">
                                                 <a href="" class="cateogry-tag green-tag">Lorem ipsum</a>
         
                                                 <a href="" class="cateogry-tag orange-tag">Lorem ipsum</a>
         
                                                 <a href="" class="cateogry-tag blue-tag">Lorem ipsum</a>
         
                                             </div>
                                             <div class="description">
                                                 <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, vestibulum molestie id quam
                                                     nec ultrices. Lorem ipsum dolor sit amet, consectetur adipiscing elit, molestie
                                                     id quam nec.</p>
                                                     <div class="list-details">
                                                             <div class="mobile-listing">mobile listing</div>
                                                     <ul>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                         <li>Lorem ipsum dolor sit amet, consectetur adipiscing.</li>
                                                     </ul>
                                                 </div>
                                             </div>
                                         </div>
                                         <div class="card-footer">
                                             <div class="selected-wrappers">
                                                 <div class="content-block">
                                                     <p>
                                                         <span class="text-bold">Variation</span>
                                                     </p>
                                                     <p>Variation</p>
                                                 </div>
                                                 <div class="content-block">
                                                     <p>
                                                         <span class="text-bold">Variation</span>
                                                     </p>
                                                     <p>Variation</p>
                                                 </div>
                                                 <div class="content-block card-btn">
                                                     <a href="" class="custom-btn">
                                                         <span>Gå til booking</span>
                                                     </a>
                                                     <a class="link-btn">Læs mere om rejsen</a>
                                                 </div>
                                             </div>
                                         </div>
                                     </div>
                                 </figcaption>
                             </figure>
                         </div>
                     </div>
               
         
         
                 </div>
             </div>
         </div>
         <div class="cta-section">
             <div class="cta-wrapper">
                     <div class="cta-content-block">
                         <div class="call">
                                 <p>call</p>
                                 <p>28 9 35 99</p>
                         </div>
                         
                     </div>
                     <div class="cta-content-block">
                             <a href="" class="custom-btn">
                                     <span>Gå til booking</span>
                                 </a>
                     </div>
                     <div class="cta-content-block">
                        
                     </div>
                 </div>
         
         </div>
         </Fragment>
         )
     }*/

    render() {
        const { match, history } = this.props;
        return (
            <Fragment >
                <div style={{marginTop:`100px`,display:`inline-table`}}></div>
                {/* <FilterSkeleton></FilterSkeleton>
                <LayoutSwithingSkeleton></LayoutSwithingSkeleton>
                <TripListSkeleton></TripListSkeleton> */}
                {/* <TravelDocumentSkeleton></TravelDocumentSkeleton> */}
                {/* <CheckoutSkeleton></CheckoutSkeleton> */}
                {/* <Checkout_2_Skeleton></Checkout_2_Skeleton> */}
                <AddonWithMediaSkeleton></AddonWithMediaSkeleton>
            </Fragment>
        )
    }
}

export default withRouter(Test)
